import { gql } from '@apollo/client';

export const SendForgotPassword = gql`
    mutation sendForgotPassword($email: String!) {
        sendForgotPassword(email: $email) {
            ... on SuccessType {
                message
            }

            ... on ErrorType {
                message
            }
        }
    }
`;
